module.exports = __webpack_public_path__ + "img/card-multi-yuri.38f9ffd6.webp";